import michelinLogo from "../../../images/logos/bib.jpg";
export var MichelinLogo = {
  LIGHT: michelinLogo,
  DARK: michelinLogo,
  DEFAULT: michelinLogo
};